module.exports = __webpack_public_path__ + "static/media/return.552468a2.svg";